<template>
  <button @click="exportData" class="btn btn-sm btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus ok-only ok-title="Cancel" @ok="close">
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportData: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/lookup-customer/customer', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            companyName: item.client ? item.client.companyName : '',
            clientPhone: item.client ? item.client.phone : '',
            clientEmail: item.client ? item.client.email : '',
            domain: item.client ? item.client.domain : '',
            customerName: item.name ? item.name : '',
            customerCode: item.code ? item.code : '',
            customerPhone: item.phone ? item.phone : '',
            customerEmail: item.email ? item.email : '',
            customerDob: item.dob ? moment(item.dob).format('DD/MM/YYYY') : '',
            createTime: item.createTime ? moment(item.createTime).format('DD/MM/YYYY HH:mm:ss') : '',
            updateTime: item.updateTime ? moment(item.updateTime).format('DD/MM/YYYY HH:mm:ss') : '',
          };
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'customer-lookup.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('companyName'), key: 'companyName', width: 15},
        {header: this.$t('clientPhone'), key: 'clientPhone', width: 15},
        {header: this.$t('clientEmail'), key: 'clientEmail', width: 15},
        {header: 'Domain', key: 'domain', width: 15},
        {header: this.$t('customerName'), key: 'customerName', width: 15},
        {header: this.$t('customerCode'), key: 'customerCode', width: 15},
        {header: this.$t('customerPhone'), key: 'customerPhone', width: 15},
        {header: this.$t('customerEmail'), key: 'customerEmail', width: 15},
        {header: this.$t('customerDob'), key: 'customerDob', width: 15},
        {header: this.$t('createTime'), key: 'createTime', width: 15},
        {header: this.$t('updateTime'), key: 'updateTime', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    },
  },
  i18n: {
    messages: {
      en: {
        customerName: "Customer name",
        customerCode: "Customer code",
        customerPhone: "Customer phone number",
        customerEmail: "Customer email",
        customerDob: "Date of birth",
        clientPhone: "Client phone number",
        clientEmail: "Client email",
      },
      vi: {
        customerName: "Tên khách hàng",
        customerCode: "Mã khách hàng",
        customerPhone: "SĐT khách hàng",
        customerEmail: "Email khách hàng",
        customerDob: "Ngày sinh",
        clientPhone: "SĐT client",
        clientEmail: "Email client",
      }
    }
  }
}
</script>